export default "__VITE_ASSET__c75ccf9f__"